var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"batch-card-body"},[_c('p',{staticClass:"batch-card-body__title"},[_c('span',{class:{
        'open': _vm.isOpen,
        'closed': _vm.isCompleted || _vm.isCollected
      }},[_vm._v("\n      "+_vm._s(_vm.batch?.total_samples)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"batch-card-body__subtitle"},[_vm._v("\n    "+_vm._s(_vm.samplesLabel)+"\n  ")]),_vm._v(" "),_c('hr',{staticClass:"batch-card-body__separator"}),_vm._v(" "),_c('div',{staticClass:"batch-card-body__description"},[_c('span',{class:{
        'open': _vm.isOpen,
        'closed': _vm.isCompleted || _vm.isCollected
      }},[_vm._v("\n      "+_vm._s(_vm.stateName)+"\n    ")])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }